// removed by extract-text-webpack-plugin
module.exports = {"container":"_38kkGWl","current":"he3XXzJ","highlight":"_1uD507y","previous":"_206h8Fg","rrp":"_255x-wT","rrpLabel":"_3a-eLYZ"};


//////////////////
// WEBPACK FOOTER
// ./template/components/MiniBag/Price/index.css
// module id = ./template/components/MiniBag/Price/index.css
// module chunks = client.sitechrome